import { Icon } from "../../util";
import { brand } from "../../../config/brand";
import * as Styled from "./styles.css";

const BackLink = ({
  title = `Back to ${brand.shortName}`,
  path = "/",
}: IBackLinkProps) => {
  return (
    <Styled.Back href={path} router>
      <Icon icon="arrow-left" color="accent" size="sm" />
      {title}
    </Styled.Back>
  );
};

export interface IBackLinkProps {
  title?: string;
  path?: string;
}

export default BackLink;
